<template>
  <div class="sub-header">
    <div class="header">
      <div class="d-flex align-items-center" v-if="candidate">
        <router-link
          :to="{
            name: 'InterviewDetailView',
            params: { interviewId: interview.interviewId, lang: $route.params.lang },
          }"
        >
        <span class="back-icon"><svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.8355 0.482461C12.2638 -0.0892057 11.3422 -0.0892057 10.7705 0.482461L1.0755 10.1775C0.620503 10.6325 0.620503 11.3675 1.0755 11.8225L10.7705 21.5175C11.3422 22.0891 12.2638 22.0891 12.8355 21.5175C13.4072 20.9458 13.4072 20.0241 12.8355 19.4525L4.38884 10.9941L12.8472 2.53579C13.4072 1.97579 13.4072 1.04246 12.8355 0.482461Z" fill="#353535"></path></svg></span>
        </router-link>
        <h1 class="bold">
          {{ `${candidate.name ? candidate.name : ''} ${candidate.surname ? candidate.surname : ''}` }} <p class="mail-text">{{ `${candidate.mail ? candidate.mail : ''}`}}</p> </h1>
      </div>
      <div class="d-flex justify-content-end" v-if="candidate && pageType === 'video'" style="min-width: 153px;">
        <b-tooltip
          v-if="disabledDownload"
          target="report-area-tooltip"
          triggers="hover"
          placement="bottom"
          :delay="{ show: 150, hide: 200 }"
          custom-class="report-tooltip"
        >
          {{ resource['upgradePlanTooltip'] }}
        </b-tooltip>
        <button id="report-area-tooltip" class="report-button" @click="downloadReport">
          <i
            v-if="downloadButtonLoading"
            class="icon-spinner icon-spin"
            width="14"
            height="14"
          />
          <svg v-if="!downloadButtonLoading" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12.6654 6.33331H9.9987V2.33331H5.9987V6.33331H3.33203L7.9987 11L12.6654 6.33331ZM7.33203 7.66665V3.66665H8.66536V7.66665H9.44536L7.9987 9.11331L6.55203 7.66665H7.33203ZM3.33203 12.3333H12.6654V13.6666H3.33203V12.3333Z" fill="#333333"/>
          </svg>
          <span v-if="!downloadButtonLoading">
            {{ resource['individualReportBtnText'] }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InterviewCandidateHeader',

  props: {
    interview: {
      type: Object,
      required: true,
    },
    tab: {
      type: Number,
      required: false,
    },
    candidate: {
      name: String,
      surname: String,
      email: String,
    },
    pageType: {
      type: String,
      required: false,
    },
    disabledDownload: {
      type: Boolean,
      required: false,
    },
    downloadButtonLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {},

  data() {
    return {};
  },

  computed: {
  },

  methods: {
    downloadReport() {
      if (this.downloadButtonLoading || this.disabledDownload) {
        return;
      }
      dataLayer.push({
        event: 'ga4_event',
        page_type: 'candidate-evaluation',
        site_type: 'interview',
        event_name: 'button_click',
        event_parameters: {
          button_name: 'individual-report',
        },
      });

      this.$emit('downloadReport');
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/style/starter.scss";

.new-page-view {
  &:has(.video-detail-new) {
    .header {
      height: 56px !important;
      overflow: hidden;
    }
  }
}

.back-icon{
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.header {
  justify-content: space-between;

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    flex-direction: column;
    gap: 16px;
    padding: 8px !important;
  }

  .switch-area {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

  .w-100-3 {
    width: calc(100% / 3);
  }

  .mail-text {
    font-size: 12px;
    font-weight: 400;
  }
}

.report-button {
  min-width: 152px;
  display: flex;
  padding: 9px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  height: 38px;
  border: 1px solid var(--Stroke-Colors-Secondary-Gray-Stroke, #D4D4D4);
  transition: all 0.2s ease-in-out;

  span {
    color: var(--Text-Colors-Primary-Gray-Text, #333);
    padding: 0 8px;
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Button & Link/2(Button Label) - Bold */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }

  &:hover {
    background: #E5E5E5;
  }
}

.report-tooltip {
  opacity: 1 !important;

  &.bs-tooltip-top {
    padding: 0 !important;
    top: 85px !important;

    ::v-deep .arrow {
      top: -12px !important;
      bottom: auto !important;

      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>') !important;
        width: 9px;
        height: 17px;
        transform: rotate(90deg);
        bottom: 2px;
      }
    }
  }

  ::v-deep .tooltip-inner {
    background: #FFF !important;
    border-radius: 4px !important;
    padding: 8px 12px !important;
    min-width: 238px !important;
    max-width: none !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6);
    border: 1px solid #E5E5E5;

    text-align: left;
    color: #333;
    font-family: Roboto !important;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
}
</style>
